module.exports = __webpack_public_path__ + "static/media/Neet-Exam.60972fde.png";